export const TASK_STATUS_PARAM = 'taskStatus';
export const TASK_GROUPING_PARAM = 'grouping';
export const MEMO_TAGS_PARAM = 'memoTagIds';
export const INTERIOR_CLEANING_PARAM = 'interiorStatus';
export const EXTERIOR_CLEANING_PARAM = 'exteriorStatus';
export const TODAY_CLEANING_PARAM = 'isDueToday';